
<div [ngClass]="['rounded', 'p-3', 'mb-3', isDarkThemeEnabled ? 'bg-black' : 'bg-white']" [attr.style]="isDarkThemeEnabled ? 'background-color: rgb(20,20,20) !important;': ''">
    <ng-content />
</div>

